import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.sales-quarter',
    method: 'get',
    params,
  })
}

export const listAll = (params?: any) => {
  return axiosService({
    url: '/api.sales-quarter/all',
    method: 'get',
    params,
  })
}

// export const listBySalesQuarter = (params?: any) => {
// 	return axiosService({
// 		url: `/api.sales-user-quarter/quarter`,
// 		method: 'get',
// 		params
// 	});
// }

export const updateSalesUserQuarter = (id: number, data: any) => {
  return axiosService({
    url: `/api.sales-user-quarter/${id}`,
    method: 'put',
    data,
  })
}

export const count = () => {
  return axiosService({
    url: `/api.sales-quarter/count-pending`,
    method: 'get',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.sales-quarter/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.sales-quarter/${id}`,
    method: 'put',
    data,
  })
}

export const reject = (id: number, data: any) => {
  return axiosService({
    url: `/api.sales-quarter/${id}/reject`,
    method: 'put',
    data,
  })
}

export const approve = (id: number, data: any = {}) => {
  return axiosService({
    url: `/api.sales-quarter/${id}/approve`,
    method: 'put',
    data,
  })
}

export const apply = (id: number) => {
  return axiosService({
    url: `/api.sales-quarter/${id}/apply`,
    method: 'put',
  })
}

export const remake = (id: number, data: any) => {
  return axiosService({
    url: `/api.sales-quarter/${id}/remake`,
    method: 'put',
    data,
  })
}
